import React from 'react';
import { Bleed, Button, Flex, Text, Tooltip } from '@applyboard/crystal-ui';
import { InfoOutlineIcon } from '@applyboard/ui-icons';
import { useScholarshipPageContext } from "../../contexts";
import { useEventTracker } from '@applyboard/ui-utils';
import { removeScholarshipDescription } from "../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var InfoBoxItemLabel = function InfoBoxItemLabel(_ref) {
  var label = _ref.label,
    labelTooltip = _ref.labelTooltip;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  if (!labelTooltip) {
    return _jsx(Flex, {
      direction: "row",
      align: "center",
      gap: 2,
      children: _jsx(Text, {
        variant: "labelM",
        children: label
      })
    });
  }
  return _jsx(Bleed, {
    mt: 2,
    mb: 2,
    children: _jsxs(Flex, {
      direction: "row",
      align: "center",
      gap: 0,
      pl: 6,
      children: [_jsx(Text, {
        variant: "labelM",
        children: label
      }), _jsx(Tooltip, {
        label: labelTooltip,
        onOpenChange: function onOpenChange(open) {
          if (open) {
            trackEvent({
              event: "Scholarship Page - Info Box - Hovered Over ".concat(label, " Tooltip"),
              data: {
                pageScholarship: removeScholarshipDescription(scholarship)
              }
            });
          }
        },
        children: _jsx(Button, {
          size: "sm",
          "aria-label": "Info",
          variant: "transparent",
          leadIcon: InfoOutlineIcon
        })
      })]
    })
  });
};